import { useMemo } from 'react';
import * as t from 'ts-schema';
import { registerQuery, useQuery } from 'data-fetching-client';
import getLang from 'I18n/utils/getLang';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
/* @ts-expect-error module is untyped */
import * as ecosystemClient from '../clients/ecosystemClient';
import { appMultiSearchResponseSchema } from 'marketplace-ui-client-types/ecosystem-service-v1/schema';
function getRecommendedApps() {
  const language = getLang();
  return ecosystemClient.searchApps({
    language,
    queries: [{
      length: 3,
      offset: 0,
      sorts: [{
        sortField: 'RELEVANCE',
        sortOrder: 'DESC'
      }]
    }]
  }).then(response => {
    const {
      results: [rawAppSearchResponse]
    } = t.assert(appMultiSearchResponseSchema, response);
    return rawAppSearchResponse.items;
  }).catch(error => {
    console.error('Error fetching recommended app results.', error);
  });
}
export const GET_RECOMMENDATIONS = registerQuery({
  fieldName: 'recommendations',
  fetcher: getRecommendedApps
});
export function useRecommendedAppsQuery() {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_RECOMMENDATIONS);
  const requestState = getDataFetchingClientRequestState(error, loading, !!data);
  const recommendedAppsData = useMemo(() => {
    const recommendedApps = data || previousData;
    if (!recommendedApps) {
      return [];
    } else {
      return recommendedApps.recommendations.filter(item => item.recommended === true);
    }
  }, [data, previousData]);
  return {
    data: recommendedAppsData,
    requestState
  };
}